var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4538 1.98369L11.4538 1.98368C11.7831 0.970253 13.2169 0.970244 13.5462 1.98368L13.5462 1.98369L15.5839 8.25532H22.1783C23.2439 8.25532 23.687 9.6189 22.8249 10.2452L17.4899 14.1213L19.5277 20.393M11.4538 1.98369L19.5277 20.393M11.4538 1.98369L9.41606 8.25532H2.82167C1.75607 8.25532 1.31304 9.6189 2.17511 10.2452L2.73711 9.47171L2.17511 10.2452L7.51008 14.1213L5.4723 20.393C5.14301 21.4064 6.30296 22.2491 7.16503 21.6228L12.5 17.7467L17.835 21.6228M11.4538 1.98369L17.835 21.6228M19.5277 20.393C19.857 21.4064 18.6971 22.2491 17.835 21.6228M19.5277 20.393L17.835 21.6228M17.6256 21.011L18.364 20.7711L17.6256 21.011C17.6255 21.0107 17.6254 21.0103 17.6253 21.01L17.6256 21.011Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.e9240eeff1ea4891439cb004976b6e93.svg";
export { ForwardRef as ReactComponent };